import sdl from '@jds/react-generated-sdl/JDSModalDesktopInternal';
import type { JDSModalDesktopInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSModalDesktopInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'dialog',
    size = 'medium',
    headerAlignment = 'left',
    isCloseable = true,
    primaryCtaDisabled = false,
    secondaryCtaDisabled = false,
    ariaLabel = 'Modal Content',
    cancelButtonCtaAriaLabel = 'Close Modal',
    _ariaModal = 'true',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      size,
      headerAlignment,
      isCloseable,
      primaryCtaDisabled,
      secondaryCtaDisabled,
      ariaLabel,
      cancelButtonCtaAriaLabel,
      _ariaModal,
      ...rest
    },
    'JDSModalDesktopInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ModalDesktopInternal = withLogic(
  Component
) as React.FC<JDSModalDesktopInternalProps> & { slotName?: string };

ModalDesktopInternal.displayName = 'ModalDesktopInternal';
ModalDesktopInternal.slotName = 'jds_modal_desktop_internal';

export { ModalDesktopInternal, type JDSModalDesktopInternalProps };
